
export function appQueryParameters(location) {
    const search = location.search.substring(1)
    const chunks = search.split('&')

    return chunks.reduce((result, chunk) => {
        const [key, value] = chunk.split('=')

        result[key] = decodeURIComponent(value)
        return result
    }, {})
}

export function appUrl(url, query) {
    const queryArray = Object.keys(query).reduce((result, key) => {
        var value = query[key]

        result.push(key.toLowerCase() + '=' + encodeURIComponent(value))
        return result
    }, [])

    const queryString = queryArray.length > 0 && ('?' + queryArray.join('&')) || ''
    return url + queryString
}


// WEBPACK FOOTER //
// ./lib/core/locationz.js